 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		113: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_uz","52":"lang_vi","53":"lang_zh_cn","54":"lang_zh_tw","55":"locale_ak","56":"locale_ar","57":"locale_be","58":"locale_bg","59":"locale_bs","60":"locale_ca","61":"locale_cs","62":"locale_da","63":"locale_de","64":"locale_el","65":"locale_en","66":"locale_es","67":"locale_et","68":"locale_fi","69":"locale_fil","70":"locale_fr","71":"locale_he","72":"locale_hi","73":"locale_hr","74":"locale_hu","75":"locale_id","76":"locale_is","77":"locale_it","78":"locale_ja","79":"locale_ka","80":"locale_kk","81":"locale_ko","82":"locale_ky","83":"locale_lt","84":"locale_lv","85":"locale_nl","86":"locale_pa","87":"locale_pl","88":"locale_pt","89":"locale_ro","90":"locale_ru","91":"locale_sk","92":"locale_sl","93":"locale_sq","94":"locale_sr","95":"locale_sr_cyrl_me","96":"locale_sv","97":"locale_sw","98":"locale_th","99":"locale_tr","100":"locale_uk","101":"locale_ur","102":"locale_uz","103":"locale_vi","104":"locale_zh","105":"loclae_af","106":"polyfills","108":"vendors~css-vars-ponyfill","109":"vendors~dompurify","110":"vendors~marked","111":"vendors~polyfills"}[chunkId]||chunkId) + "." + {"0":"5ab37256429983896f82","2":"1f7bd342464e6d87ff3d","3":"2d62380a042dfbd05ffe","4":"0c3def03019aa2179058","5":"71a965530fcad412d7e2","6":"23efdacddf9fa81367be","7":"55927c8cc91d28eda800","8":"1b2100dc943a18ecb10d","9":"2d868b0bdf44f8a3edbf","10":"b66ed3422eebaca92c5e","11":"6dbb42d8d580de740a5b","12":"59800c44f93246b05c94","13":"fa2ac0d73c74cdf9e524","14":"5853e2540cfa68a7c06e","15":"7edfc669a1e0ded22c93","16":"5c3d90daa8978d496ee3","17":"8ade964f8d23e7c14aae","18":"8830d0d052cfa66d80df","19":"68adcb0e22810b7e5c9d","20":"e7fe70715ad82389c832","21":"ee8db7b99e110cfede47","22":"997f4bd26edc211776a3","23":"88372165ebc27683708d","24":"93f268836ea82c0cfec0","25":"540bbbf10f9cb2cac718","26":"0de359e294fd7985afa5","27":"7a8e3a4fb6a019410ae7","28":"92bd98251826204fba46","29":"f518f014a1ab3133b917","30":"fc9fe0cbdc6aa877b3b8","31":"7c223a95fe1b95ea7c9d","32":"5348a35ce3ebfe1775e0","33":"1ec3fd7e1e8376bb0ab3","34":"b20a838e5332f5294af1","35":"733ff9735c55ce5f9ff4","36":"6c4d2e11568a05b38a46","37":"de05b9f16e35cdb99739","38":"2d27c70b0be86131a50f","39":"a2f73fe0b2eb64024951","40":"f478a487865575169a7b","41":"289f8a796c1f3c56c2c6","42":"c763b6d0f6cf0dc72e8b","43":"708d99d9e2c48b2e2ae1","44":"b428cb2642520bd7d315","45":"204a980c6b518bd7d274","46":"e3c4becf628aa6858b82","47":"f4174d4f90c2d0883682","48":"a9e95f19f8cfc3201d8b","49":"34d2cbcc9c85643c988a","50":"4f474047995a92b570bd","51":"5e2a2419b5396d50b706","52":"62512c8bb5bcca4e7dc2","53":"47887672b1b37db3c8cf","54":"79e170663a4a139a64f2","55":"fe54e47f39b91e147c3f","56":"47274fec771c65f90530","57":"62e53440dfcbbfc73789","58":"a748cbea5979f89a6c86","59":"020d78c15155a2b765fd","60":"c94cff94a3c09af9270b","61":"688cf532c6344d2b3a68","62":"d9d203eb8d326dad5d81","63":"1842cfb372cc0eab0930","64":"849e884e68b9c15c26b9","65":"59b28184045037a6e7b8","66":"9d21f64155aecb0076e2","67":"b622728d2cf9e902abb1","68":"d9c216d6bf9850912f38","69":"584bdd00c1cf8b4838f4","70":"2d268f66a880ed0074e9","71":"37302b46460bdf6eaef6","72":"935307dc423d8d4810de","73":"5e8bb6b01a37f0daf1dd","74":"b041fe01f48eee9095ea","75":"fd8a91b4648b10756606","76":"3e6113fb2c29d4b40fcc","77":"b8c4154bad2b732baeb6","78":"3e5f856107871af9bc0f","79":"630df4bfb8d4a451542b","80":"4e400de83ca4b3f3a95f","81":"d3a26236ff1a52df8e0b","82":"d1085d9d27b5a3ad8a05","83":"ce173deda856866e35b3","84":"ac4e4cf7b8e88fd12c9b","85":"d89530e814d2d55032da","86":"ea0fc4144f81e4745a33","87":"59450fa2fa03c77093d4","88":"ba27fe7ddfa578b533eb","89":"a9ccfb0adfe58914946e","90":"6f7bd6652d6d695aaa6f","91":"2f6a94301cbc058e143f","92":"4047341e5dcbd6f88b45","93":"9241c4e76044bb593db7","94":"a567fe2e6301aad162ad","95":"d2c3b7e6d8da4f74d479","96":"ef7a7e34ca63b494537b","97":"afa3a960a6491f8fa1bf","98":"3772e3871f6005d9a2f8","99":"b2dcedd59fadde01aeb1","100":"a5b03953ede0d12750f2","101":"7a6847d0f6b4a9b1c580","102":"a6babc25036ce3015f64","103":"31d476e1a06eb81d0db1","104":"097ccabb42520d645781","105":"c545ed0c0bfcc496280c","106":"828434c8e94246a7eea4","108":"48e1647491975ac5e004","109":"c426e846910a7a474afa","110":"011daa948164a6686fd8","111":"acdcfe6139d132da4f65"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/release-v0.1.215/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 96);
